import axios from 'axios';
import CONFIG, { getApiUrl } from '../../../utils/config';

interface RegisterRequest {
  username: string;
  password: string;
  email: string;
  firstName: string;
  lastName: string;
  gender: 'MALE' | 'FEMALE' | 'OTHER';
}

interface RegisterResponse {
  id?: number;
  username?: string;
  message?: string;
}

export const registerUser = async (data: RegisterRequest): Promise<RegisterResponse> => {
  try {
    const response = await fetch(getApiUrl(CONFIG.ENDPOINTS.AUTH.REGISTER), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    const responseData = await response.json();
    
    if (!response.ok) {
      return {
        message: responseData.message || 'Đăng ký thất bại',
      };
    }
    
    return responseData;
  } catch (error) {
    return {
      message: 'Đã xảy ra lỗi khi kết nối đến máy chủ',
    };
  }
};

export default {
  registerUser
};
